// extracted by mini-css-extract-plugin
export default {"MinimizedPanel":"MinimizedPanel_MinimizedPanel__YUBwM","Title":"MinimizedPanel_Title__LRukp","ExpandButton":"MinimizedPanel_ExpandButton__caPCX"};